import { createFileRoute } from '@tanstack/react-router';

import { DeleteAccountConfirmation } from 'src/apps/account/app/components/DeleteAccount';

export const Route = createFileRoute(
  '/_auth/(no-layout)/account/delete/confirmation/app'
)({
  component: () => <DeleteAccountConfirmation variant="app" />,
});
